import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MdDialog, MdSort } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AppMessage } from '../../Common/appMessage';
import { TableDataSource } from './../../Common/md-table';
import { Utility } from './../../Common/Services/utility';
import {
  AdmRemoveOfficeComponent,
} from './../../Components/adm-manage-office/adm-remove-office/adm-remove-office.component';
import { AdmManageOfficeService } from './adm-manage-office.service';

@Component({
  selector: 'app-adm-manage-office',
  templateUrl: './adm-manage-office.component.html',
  styleUrls: ['./adm-manage-office.component.css'],
  providers: [AdmManageOfficeService]
})
export class AdmManageOfficeComponent implements OnInit {
  @ViewChild(MdSort) sort: MdSort;
  officeName: FormControl = new FormControl();
  dataSource: TableDataSource | null;
  dataSubject: BehaviorSubject<IElement[]> = new BehaviorSubject<IElement[]>([]); // store all grid data
  displayedColumns = ['name', 'Action'];
  recordCount: number = 0;
  officesList: any;
  constructor(public _utility: Utility, public _admManageOfficeService: AdmManageOfficeService,
    private _activatedRoute: ActivatedRoute, private _router: Router, public _appMessage: AppMessage,
    private _dialog: MdDialog) {
  }

  ngOnInit() {
    this.loadOfficeRecord();
    this.dataSource = new TableDataSource(this.dataSubject, null, this.sort);

    this.officeName.valueChanges
      .distinctUntilChanged()
      .debounceTime(200)
      .subscribe(value => {
        if (value) {
          this._utility.setTxnStatus(true);
        } else {
          this._utility.clearTxnStatus();
        }
      });
  }

  loadOfficeRecord() {
    this._utility.addLoaderCount();
    this._admManageOfficeService.getData()
      .subscribe(
      response => {
        this._utility.onSuccessCallback(response, null, () => {
          this.dataSubject.next(response.response.results);
          this.officesList = response.response.results;
          this.recordCount = response.response.results.length; // get number of records so that we can display grid or not based on this
        });
      },
      error => {
        //
        this._utility.onErrorCallback(error);
      });

  }
  onAddOffice() {
    let params = { officeName: this.officeName.value.trim() };
    this._admManageOfficeService.saveData(params).subscribe(response => {
      this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00061'], () => {
        this.officeName.reset();
        this._utility.clearTxnStatus();
        this.loadOfficeRecord();
      });
    }, error => this._utility.onErrorCallback(error));
  }

  onRemove(element: any): void {
    let data = { officeList: this.officesList, element };
    this._dialog.openDialogs.pop();
    const dialogRef = this._dialog.open(AdmRemoveOfficeComponent, {
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.loadOfficeRecord();
      }
    });
  }
}
// Created Interface for manage exam fields
export interface IElement {
  id: number,
  officeName: string
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-office/adm-manage-office.component.ts